module.exports = __webpack_public_path__ + "img/8405.e8e01087.jpg";